import * as React from 'react'
import { use } from 'react'

export interface CheckoutContext {
  contextItemId: string
  draftId?: string | null
  setDraftId?: (draftId: string | null) => void
  step?: number
}

export const CheckoutReactContext = React.createContext<CheckoutContext | null>({
  contextItemId: '',
  draftId: null,
  setDraftId: () => {},
  step: undefined,
})

export function useCheckoutContext() {
  const context = use(CheckoutReactContext)
  if (!context) {
    throw new Error(
      'Attempted to access checkout context before initializing it, please use CheckoutReactContext to initialize the context.',
    )
  }

  return context
}
